import React from "react";

import { TableRow, TableCell } from "@mui/material";
import MemoizedSwitchColumnas from "../../../SwitchColumnas";
import Checkbox from "@mui/material/Checkbox";
import { getAtributo } from "../../../../../context/FuncionesContext";

// {
//     data = {},
//     cab,
//     padre,
//     indiceData,
//     Context = ListadoContext,
//     id_elemento,
//  }

function TableRowO({
  data,
  cabeceras,
  rowState,
  updateState,
  listadoSeleccion,
  onCheck,
}) {
  const columnas_tipo_fila = cabeceras.filter(
    (c) => c.mostrar_como_fila === "s"
  );
  return (
    <React.Fragment key={data._key}>
      <TableRow>
        {listadoSeleccion ? (
          <TableCell sx={{ width: "5%" }}>
            <Checkbox
              sx={{ padding: 0 }}
              checked={rowState._checked ?? false}
              onClick={onCheck}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onCheck(e);
                }
              }}
              tabIndex={0}
            />
          </TableCell>
        ) : (
          <></>
        )}
        {cabeceras.map((c) => {
          if (c.componente === "hidden") return <React.Fragment key={c.id_a} />;
          if (c.mostrar_como_fila === "s")
            return <React.Fragment key={c.id_a} />;
          return (
            <TableCell key={c.id_a}>
              <MemoizedSwitchColumnas
                indiceData={data._key}
                data={rowState}
                cab={c}
                updateState={updateState}
              />
            </TableCell>
          );
        })}
      </TableRow>
      {columnas_tipo_fila.map((c) => {
        if (!getAtributo("mostrar", data, c))
          return <React.Fragment key={c.id_a} />;
        return (
          <TableRow>
            <TableCell
              key={c.id_a}
              colSpan={cabeceras.length + (listadoSeleccion ? 1 : 0)}
            >
              <MemoizedSwitchColumnas
                indiceData={data._key}
                data={rowState}
                cab={c}
                updateState={updateState}
              />
            </TableCell>
          </TableRow>
        );
      })}
    </React.Fragment>
  );
}

export default TableRowO;
